<template>
  <div class="ViavenirCollegeReport mb-5" style="font-size: 18px">
    <img class="mx-4 mb-4"
         src="viavenir/logo.png">
    <div class="header-band primary white--text full-width">
      <h1 class="py-3 px-5"
          style="font-size: 37px;">
        <span style="text-transform: uppercase; font-weight: 100">Rapport | </span>
        <span style="font-weight: 700">{{report.patient.first_name}} {{report.patient.last_name}}</span>
      </h1>
    </div>

    <div class="text-center">
      <img src="viavenir/report-hero.jpg"
           style="max-width: 100%;"
           alt="Rapport ViAvenir">
    </div>
        <div class="header-band primary white--text full-width">
          <h2 class="py-3 px-5"
              style="font-weight: 100; font-size: 32px;">
            Votre coach :
            <b>{{report.patient.doctor.first_name}} {{report.patient.doctor.last_name}}</b>
          </h2>
        </div>

        <div class="px-5">
          <div class="report-header primary--text mt-5" style="text-transform: initial">Contexte et problématique</div>
          <div v-if="commentaireCoach">
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.contexte"></p>

            <div class="report-header primary--text mt-5" style="text-transform: initial">Personnalité, intérêts et motivations</div>
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.personalite"></p>

            <div class="report-header primary--text mt-5" style="text-transform: initial">Environnement et secteurs d’activité identifiés</div>
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.environnement"></p>

            <div class="report-header primary--text mt-5" style="text-transform: initial">Réflexion et prise de conscience</div>
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.reflexion"></p>

            <div class="report-header primary--text mt-5" style="text-transform: initial">Hypothèses de poursuite d’études et perspectives</div>
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.hypotheses"></p>

            <div class="report-header primary--text mt-5" style="text-transform: initial">Orientation en section ou options</div>
            <p class="report-caption"
               style="margin-top: 10px; margin-left: 20px"
               v-html="commentaireCoach.orientation"></p>
          </div>
          <div v-else>
            Aucun commentaire coach n'a été renseigné
          </div>
        </div>

        <div class="px-5">
          <div class="report-header primary--text mt-5">Mission 1</div>
          <div class="report-subheader primary--text">Questionnaire sur les secteurs d'activité</div>

          <div v-if="mission1">
            <p class="mt-4 mb-0"><b>Questionnaire en 2 étapes :</b></p>
            <p> Demain, dans quel domaine aimerais-je travailler ?</p>
            <hr class="primary mb-4"
                style="height: 1px; border: 0">
            <div class="step-btn primary white--text">Étape 1</div>
            <p class="report-caption mt-4">Pour chacune des questions suivantes, cocher la case correspondant à son niveau de motivation : beaucoup (+), moyennement (=), pas du tout (-).</p>
            <table class="mb-4">
              <thead>
                <th style="text-align: left">Vos réponses</th>
                <th style="text-align: center">Résultat</th>
              </thead>
              <tbody>
                <tr v-for="(secteur, key) in mission1.data[0]">
                  <td>{{key}}</td>
                  <td style="text-align: center">{{secteur}}</td>
                </tr>
              </tbody>
            </table>

            <div class="step-btn primary white--text">Étape 2</div>
            <div class="report-caption mt-4">Parmi les secteurs d'activité qui me motivent, quels sont les cinq que je retiens en priorité ?</div>

            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="secteur in mission1.data[1]"
                  :key="secteur">{{secteur}}
              </li>
            </ul>
          </div>
          <div v-else>
            La mission 1 n'a pas encore été faite
          </div>
        </div>

        <div class="px-5 mt-5">
          <div class="report-header primary--text mt-5">Mission 2</div>
          <div class="report-subheader primary--text">Questionnaire sur les motivations</div>

          <div v-if="mission2">
            <p class="mt-4 mb-0"><b>Questionnaire en 2 étapes :</b></p>
            <p>Quelles activités me motivent ?</p>
            <hr class="primary mb-4"
                style="height: 1px; border: 0">
            <div class="step-btn primary white--text">Étape 1</div>
            <p class="report-caption mt-4">Pour chacune des questions suivantes, cocher la case correspondant à son niveau de motivation : beaucoup (+), moyennement (=), pas du tout (-).</p>

            <table class="mb-4">
              <thead>
                <th style="text-align: left">Vos réponses</th>
                <th style="text-align: center">Résultat</th>
              </thead>
              <tbody>
                <tr v-for="(secteur, key) in mission2.data[1]">
                  <td>{{key}}</td>
                  <td style="text-align: center">{{secteur}}</td>
                </tr>
              </tbody>
            </table>

            <div class="step-btn primary white--text">Étape 2</div>
            <div class="report-caption mt-4">Parmi mes motivations, quelles sont les cinq que je retiens en priorité ?</div>

            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="secteur in mission2.data[0]"
                  :key="secteur">{{secteur}}
              </li>
            </ul>
          </div>
          <div v-else>
            La mission 2 n'a pas encore été faite
          </div>
        </div>

        <div class="px-5 mt-5">
          <div class="report-header primary--text mt-5">Mission 3</div>
          <div class="report-subheader primary--text">Quelles sont mes forces de caractère ?</div>
          <div v-if="mission3">
            <p class="mt-4"><b>Questionnaire en 2 étapes :</b></p>
            <hr class="primary mb-4"
                style="height: 1px; border: 0">
            <div class="step-btn primary white--text">Étape 1</div>
            <p class="report-caption mt-4">Classez les 30 mots/photos de la liste ci-dessous en cinq groupes, en plaçant chacune des qualités citées dans un de ces cinq groupes, dans la limite de 5 caractéristiques par groupe.</p>

            <p><b>Ce n'est pas moi : </b>un mot/une qualité qui n’est ni l’une de mes forces, ni mon potentiel, ni mes compétences ou faiblesses. Cela ne s’applique tout simplement pas à moi. </p>
            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="force in groupBy(mission3.data.forces, 'value')['Ce n\'est pas moi']">{{force.label}}
              </li>
            </ul>

            <hr class="my-4">

            <p><b>Mes forces : </b>mes qualités dont j'ai déjà conscience et que j'utilise car elles me permettent d'atteindre le meilleur de moi-même.</p>
            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="force in groupBy(mission3.data.forces, 'value')['Mes forces']">{{force.label}}
              </li>
            </ul>

            <hr class="my-4">

            <p><b>Mes potentiels : </b>mes forces que je ne suis peut-être pas capable d’exprimer de manière quotidienne, mais dont je tire énergie et satisfaction lorsque je les déploie.</p>
            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="force in groupBy(mission3.data.forces, 'value')['Mes potentiels']">{{force.label}}
              </li>
            </ul>

            <hr class="my-4">

            <p><b>Mes compétences : </b>les comportements que j’ai appris à faire bien avec le temps, peu importe si j’en tire ou pas de plaisir ou d’énergie à les faire.</p>
            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="force in groupBy(mission3.data.forces, 'value')['Mes compétences']">{{force.label}}
              </li>
            </ul>

            <hr class="my-4">

            <p><b>Mes faiblesses : </b>les comportements que je ne sais tout simplement pas faire bien et qui me demandent beaucoup d’efforts, voire qui m’épuisent.</p>
            <div class="report-subheader primary--text mt-4">Vos réponses</div>
            <ul>
              <li style="font-weight: 700;"
                  v-for="force in groupBy(mission3.data.forces, 'value')['Mes faiblesses']">{{force.label}}
              </li>
            </ul>

            <hr class="primary my-4"
                style="height: 1px; border: 0">

            <div v-if="mission3.data.rankedForces && mission3.data.rankedPotentiels">
              <div class="step-btn primary white--text mb-4">Étape 2</div>
              <p class="report-caption">Revenir sur la liste de mots sélectionnés en groupe 2 (mes forces) et groupe 3 (mes potentiels) et les classer par ordre d’importance, de celui qui me caractérise le plus, à celui qui me caractérise le moins.</p>

              <p class="primary--text"><b>Mes forces</b></p>
              <ol>
                <li class="fw500"
                    v-for="force in mission3.data.rankedForces"
                    :key="force">{{force}}
                </li>
              </ol>

              <p class="mt-2 primary--text"><b>Mes potentiels</b></p>
              <ol>
                <li class="fw500"
                    v-for="potentiel in mission3.data.rankedPotentiels"
                    :key="potentiel">{{potentiel}}
                </li>
              </ol>
            </div>
          </div>
          <div v-else>
            La mission 3 n'a pas encore été faite
          </div>
        </div>
  </div>
</template>

<script>
  import groupBy from 'lodash/groupBy'
  import Logo from 'components/common/Logo'

  export default {
    components: {Logo},

    computed: {
      commentaireCoach () {
        return this.report.data.comments; ///TODO
      },

      mission1 () {
        return this.report.data.missions.filter(d => d.module.label === 'Quels sont les secteurs d\'activité qui m\'intéressent ?')[0]
      },

      mission2 () {
        return this.report.data.missions.filter(d => d.module.label === 'Ce que j\'ai envie de faire... Ou pas !')[0]
      },

      mission3 () {
        return this.report.data.missions.filter(d => d.module.label === 'Qui suis-je ?')[0]
      }
    },

    methods: {
      groupBy () {
        return groupBy(...arguments)
      }
    },

    props: {
      report: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .ViavenirCollegeReport {
    font-family: 'Helvetica', sans-serif;

    .full-width {
      margin: 0 -16px;
    }

    .report-header {
      font-size: 24px;
      text-transform: uppercase;
      font-weight: 700;
    }

    .report-subheader {
      font-size: 20px;
      font-weight: 700;
    }

    .report-caption {
      font-weight: 100;
      font-style: italic;
    }

    .step-btn {
      font-weight: 700;
      display: inline-block;
      padding: 8px 12px;
      border-radius: 13px;
    }

    table {
      width: 100%;
      border-spacing: 0;

      thead {
        background: #EA5B0C;
        color: white;
      }

      th {
        padding: 5px 20px;
      }

      td {
        padding: 5px 20px;
      }

      tr:nth-child(odd) {
        background-color: #F6DFD4;
      }

      tr:nth-child(even) {
        background-color: #FFF5F1;
      }
    }
  }
</style>
